import { combineReducers } from "@reduxjs/toolkit";
import runSlice from "./runReducer";
import driverSlice from "./driverReducer";
import vehicleSlice from "./vehicleReducer";
import reportSlice from "./reportReducer";
import whsSlice from "./whsReducer";
export const rootReducer=combineReducers({
    run: runSlice,
    vehicle: vehicleSlice,
    driver: driverSlice,
    report: reportSlice,
    whs: whsSlice
})